export default "__VITE_PUBLIC_ASSET__12e7013f__"